import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var key_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
  Path,
  {
    d: "M9 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 16a4.002 4.002 0 003.8-2.75H15V16h2.5v-2.75H19v-2.5h-6.2A4.002 4.002 0 005 12a4 4 0 004 4z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }
) });
export {
  key_default as default
};
//# sourceMappingURL=key.js.map
